const reviewsElement = () => {

    const link        = $('.js-reviews-element-link');
    const activeClass = '_active';

    link.on('click', function(){
        const parent        = $(this).parents('.js-reviews-element');
        const preview       = parent.find('.js-reviews-element-preview');
        const text          = parent.find('.js-reviews-element-text');
        const textHeight    = text.height();
        const previewHeight = preview.attr('data-height');

        if ( !previewHeight ) {
            preview.attr('data-height', preview.height())
        }

        const expanded      = $(this).attr('data-expanded-text');
        const collapsed     = $(this).attr('data-collapsed-text');

        if ( !parent.hasClass(activeClass) ) {
            parent.addClass(activeClass);
            preview.animate({
                maxHeight: textHeight + 'px'
            }, 300);
            $(this).text(expanded);
        }
        else {
            parent.removeClass(activeClass);
            preview.animate({
                maxHeight: preview.attr('data-height') + 'px'
            }, 300);
            $(this).text(collapsed);
        }

    });
}